const navLinks = [
  {
    url: '/app/profile',
    label: 'Edit Profile',
  },
];

export default navLinks;
